import { useEffect } from "react";
import { HuulgaWidget } from "../../widgets/huulga";

export const HuulgaPage = () => {
  useEffect(() => {
    document.title = "Хуулга";
  }, []);
  return (
    <div className="page">
      <HuulgaWidget />
    </div>
  );
};
